import { lazy } from 'react'

export const CaloriesEqualityV1 = lazy(() => import('./v1/CaloriesEqualityV1'))
